module.exports = {"id":"230019","name":"Vital Nsimba","rating":"71","photo":"./data/images/photos/2/230019.png","club":{"name":"Bourg en Bresse","logo":"./data/images/clubs/BourgenBresse.png"},"positions":["DG","MG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/VitalNsimba0.json
// module id = 4286
// module chunks = 0